import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Ui input semantic
 * Display the semantic component Input using the corresponding mode
 * The label is located inside the input element
 * Props (parameters)
 * @param id: PropTypes.string
 * @param icon: PropTypes.string
 * @param iconPosition: PropTypes.string [left]
 * @param value: PropTypes.string
 * @param label: PropTypes.string
 * @param labelPosition: PropTypes.string [leftrightleft cornerright corner]
 * @param onchange: PropTypes.func
 * @param onBlur: PropTypes.func
 * @param disabled: PropTypes.bool
 * @param fluid: PropTypes.bool
 * @param mode: PropTypes.string
 */
export default class UiInputSemantic extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.state = {
      focus: false,
    };
  }

  onFocusIn() {
    this.setState({ focus: true });
  }

  onFocusOut() {
    this.setState({ focus: false });
  }

  render() {
    const {
      id,
      icon,
      iconPosition,
      value,
      label,
      labelPosition,
      onChange,
      onBlur,
      fluid,
      mode,
      disabled,
    } = this.props;
    const { focus } = this.state;
    const styleInput = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleInput.backgroundColor = modeColors.INPUT_BACKGROUND_COLOR;
      styleInput.color = modeColors.INPUT_COLOR;
      styleInput.borderColor = focus
        ? modeColors.INPUT_FOCUS_BORDER_COLOR
        : modeColors.INPUT_BORDER_COLOR;
    }
    let input = (
      <Input
        className={`${mode !== null ? 'ui-input-semantic' : ''}`}
        style={styleInput}
      />
    );
    input = (
      <input.type
        {...input.props}
        {...(id ? { id } : {})}
        {...(icon ? { icon } : {})}
        {...(iconPosition ? { iconPosition } : {})}
        {...(value ? { value } : {})}
        {...(label ? { label } : {})}
        {...(labelPosition ? { labelPosition } : {})}
        {...(onChange ? { onChange } : {})}
        {...(onBlur ? { onBlur } : {})}
        {...(disabled ? { disabled } : {})}
        {...(fluid ? { fluid } : {})}
      />
    );
    return (
      <div onFocus={this.onFocusIn} onBlur={this.onFocusOut}>
        {input}
      </div>
    );
  }
}

UiInputSemantic.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  mode: PropTypes.string,
};

UiInputSemantic.defaultProps = {
  id: null,
  icon: null,
  iconPosition: null,
  value: null,
  label: null,
  labelPosition: null,
  onChange: null,
  onBlur: null,
  disabled: false,
  fluid: null,
  mode: null,
};
